import React, { Component } from "react";
import { connect } from "react-redux";
import { setUserName } from "./store/actions/userActions";
import { receiveMessage } from "./store/actions/messageActions";
import { HubConnectionBuilder } from "@aspnet/signalr";
import Cookies from "js-cookie";

import AddMessageForm from "./components/AddMessageForm";
import ChatRoomList from "./components/ChatRoomList";
import MessageList from "./components/MessageList";
import NoRoomSelected from "./components/NoRoomSelected";
import { createAuthProvider } from "react-token-auth";

import { GetLegacyUrl, GetMessageUrl } from "./config";

import "./App.css";

class App extends Component {
  constructor() {
    super();

    var legacyUrl = GetLegacyUrl();
    var messageUrl = GetMessageUrl();

    this.connection = new HubConnectionBuilder()
      .withUrl(messageUrl + "/chatHub", {
        accessTokenFactory: () => getToken(legacyUrl),
      })
      .build();

    this.state = { token: "", isAuthenticating: true };
  }

  componentDidMount() {
    const token = Cookies.get("token");

    if (token != null) {
      login(token);
      this.setState({ isAuthenticating: false });
    } else {
      var url = GetLegacyUrl();
      authFetch(url + "/api/token/getopenidtoken?clientId=chat", { credentials: "include" })
        .then((r) => r.json())
        .then((r) => {
          login(r);
          this.setState({ isAuthenticating: false });
        });
    }

    this.connection.start({ withCredentials: true }).catch((err) => console.error(err.toString()));
  }

  render() {
    if (this.state.isAuthenticating) return null;

    const { userName, currentRoom } = this.props;

    var qs = require("qs");
    const clientId = qs.parse(window.location.search, { ignoreQueryPrefix: true }).clientid;

    return (
      <div className={clientId ? "App-withoutrooms" : "App"}>
        <ChatRoomList openRoom={() => 1} connection={this.connection} token={this.state.token} />
        {currentRoom ? <MessageList roomId={currentRoom.id} connection={this.connection} /> : <NoRoomSelected />}
        {currentRoom ? (
          <AddMessageForm roomId={currentRoom.id} userName={userName} connection={this.connection} />
        ) : null}
      </div>
    );
  }
}

function getToken(legacyUrl) {
  if (Cookies.get("token") != null) {
    return Cookies.get("token");
  } else {
    return authFetch(legacyUrl + "/api/token/getopenidtoken?clientId=chat", { credentials: "include" }).then((r) =>
      r.json()
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userName: state.userInfo.userName,
    currentRoom: state.requestRooms.currentRoom,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetUserName: (name) => dispatch(setUserName(name)),
    onReceiveMessage: (user, message, roomId, messageId, postedAt, currentRoomId) =>
      dispatch(receiveMessage(user, message, roomId, messageId, postedAt, currentRoomId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

export const [useAuth, authFetch, login, logout] = createAuthProvider({
  //accessTokenKey: 'accessToken',
  onUpdateToken: (token) =>
    fetch(GetLegacyUrl() + "/api/token/getopenidtoken?clientId=chat", {
      credentials: "include",
      method: "POST",
      body: token.refreshToken,
    }).then((r) => r.json()),
});



// WEBPACK FOOTER //
// ./src/App.js